var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0175 2.9248C7.25914 2.9248 5.01747 5.16647 5.01747 7.9248V10.3331C5.01747 10.8415 4.80081 11.6165 4.54247 12.0498L3.58414 13.6415C2.99247 14.6248 3.40081 15.7165 4.48414 16.0831C8.07581 17.2831 11.9508 17.2831 15.5425 16.0831C16.5508 15.7498 16.9925 14.5581 16.4425 13.6415L15.4841 12.0498C15.2341 11.6165 15.0175 10.8415 15.0175 10.3331V7.9248C15.0175 5.1748 12.7675 2.9248 10.0175 2.9248Z",
    stroke: "#48433E",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5599 3.16621C11.3016 3.09121 11.0349 3.03288 10.7599 2.99954C9.9599 2.89954 9.19323 2.95788 8.47656 3.16621C8.71823 2.54954 9.31823 2.11621 10.0182 2.11621C10.7182 2.11621 11.3182 2.54954 11.5599 3.16621Z",
    stroke: "#48433E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5156 16.3838C12.5156 17.7588 11.3906 18.8838 10.0156 18.8838C9.33229 18.8838 8.69896 18.6005 8.24896 18.1505C7.79896 17.7005 7.51562 17.0671 7.51562 16.3838",
    stroke: "#48433E",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.5b66b017d298326a6c8f076f1fad3c06.svg";
export { ForwardRef as ReactComponent };